module.exports = __webpack_public_path__ + "img/blockspin-reel-splash.cccfbd2f.png";